// import logo from './logo.svg';
// import './App.css';

import Navbar from "./Components/NavbarComponents";
import SidebarComponents from "./Components/SidebarComponents";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from "./Components/Home";
import Dashboard from "./Components/Dashboard";
import DashboardDetail from "./Components/DashboardDetail";
import ListJobVacancy from "./Components/ListJobVacancy";
import ListJobVacancyForm from "./Components/ListJobVacancyForm";
import Footer from "./Components/Footer";
import { GlobalProvider } from "./context/GlobalContext";
import ListJobVacancyData from "./Components/ListJobVacancyData";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GlobalProvider>
          <Navbar />
          <div className="flex fluid sm:h-full semi-md:h-full md:h-full lg:h-full xl:h-full">
            <SidebarComponents />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/list-job-vacancy" element={<ListJobVacancy />} />
              <Route path="/dashboard/list-job-vacancy/form" element={<ListJobVacancyForm />} />
              <Route path="/dashboard/list-job-vacancy/form/:IdData" element={<ListJobVacancyForm />} />
              <Route path="/list-job" element={<ListJobVacancyData />} />
              <Route path="/list-job/:IdData" element={<DashboardDetail />} />
            </Routes>
          </div>
        </GlobalProvider>
        <Footer name="Rahmat Rafli" />
      </BrowserRouter>
    </div>
  );
}

export default App;
